import decode from 'jwt-decode';
import dayjs from 'src/utils/dayjs';
import { navigate } from 'src/utils/navigate';
import { SnackBarVariants } from 'src/utils/constants/common';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import {
  removeLocalStorage,
  setLocalStorage,
  getLocalStorage
} from 'src/utils/localStorage';
import { addCardToClient } from 'src/services/creditCardsService';
import { showMessage } from './snackBarActions';

export const VALIDATE_CARD_FORM_TOKEN = asyncActionCreator(
  'VALIDATE_CARD_FORM_TOKEN'
);

export const ADD_CARD_TO_CLIENT = asyncActionCreator('ADD_CARD_TO_CLIENT');

export const GET_CARD_FORM_TOKEN_DATA = 'GET_CARD_FORM_TOKEN_DATA';
export const CLEAR_CARD_FORM_TOKEN = 'CLEAR_CARD_FORM_TOKEN';

// Map backend error codes to full translation paths
const mapBackendErrorToTranslation = errorMessage => {
  const backendErrorCodes = [
    'TOKEN_EXPIRED',
    'TOKEN_INVALID',
    'TOKEN_ALREADY_USED',
    'TOKEN_MALFORMED'
  ];

  if (errorMessage && backendErrorCodes.includes(errorMessage)) {
    return `OPENPAY_CARD_FORM.ERRORS.${errorMessage}`;
  }

  return errorMessage;
};

export const decodeTokenForCardForm = token => async dispatch => {
  const redirect = () => {
    setTimeout(() => {
      const redirectUrl =
        process.env.REACT_APP_URL_DEFAULT_REDIRECT || 'https://astrocap.com/';
      return window.location.replace(redirectUrl);
    }, 5000);
  };

  try {
    const existingToken = getLocalStorage('temporalToken');
    if (existingToken) {
      removeLocalStorage('temporalToken');
    }

    const decodeToken = decode(token);

    if (dayjs.tz().isAfter(dayjs.unix(decodeToken.exp))) {
      dispatch({ type: VALIDATE_CARD_FORM_TOKEN.failure });

      dispatch(
        showMessage({
          message: 'ERRORS.EXPIRED_TOKEN',
          variant: SnackBarVariants.ERROR
        })
      );

      setTimeout(() => {
        redirect();
      }, 500);
      return;
    }

    dispatch({ type: VALIDATE_CARD_FORM_TOKEN.start });

    setLocalStorage('temporalToken', token);
    dispatch({
      type: GET_CARD_FORM_TOKEN_DATA,
      payload: decodeToken
    });

    dispatch({ type: VALIDATE_CARD_FORM_TOKEN.success });
  } catch (error) {
    removeLocalStorage('temporalToken');
    dispatch({ type: VALIDATE_CARD_FORM_TOKEN.failure });

    dispatch(
      showMessage({
        message: 'OPENPAY_CARD_FORM.ERRORS.TOKEN_INVALID',
        variant: SnackBarVariants.ERROR
      })
    );

    setTimeout(() => {
      redirect();
    }, 500);
  }
};

export const clearCardFormToken = () => async dispatch => {
  removeLocalStorage('temporalToken');
  dispatch({
    type: CLEAR_CARD_FORM_TOKEN
  });
  dispatch({
    type: VALIDATE_CARD_FORM_TOKEN.failure
  });
};

export const saveCardToClient = cardData => async dispatch => {
  try {
    dispatch({ type: ADD_CARD_TO_CLIENT.start });

    const response = await addCardToClient(cardData);

    dispatch(
      showMessage({
        message: 'OPENPAY_CARD_FORM.SUCCESS.CARD_SAVED',
        variant: SnackBarVariants.SUCCESS
      })
    );

    navigate('/add-card-success');

    return dispatch({
      type: ADD_CARD_TO_CLIENT.success,
      payload: response
    });
  } catch (error) {
    const errorMessage = error.message
      ? mapBackendErrorToTranslation(error.message)
      : 'OPENPAY_CARD_FORM.ERRORS.SAVE_FAILED';

    dispatch(
      showMessage({
        message: errorMessage,
        variant: SnackBarVariants.ERROR
      })
    );
    return dispatch({ type: ADD_CARD_TO_CLIENT.failure });
  }
};
